import { defineComponent as _defineComponent } from 'vue'
import { Icon, Typo } from '@travelata-libs/ui-kit';
    import { computed } from 'vue';
    import { MIR_CASHBACK_TEXT } from '../../lib/filterByMirCashback';
    import MirCashbackIcon from './MirCashbackIcon.vue';
    import MirCashbackInfo from './MirCashbackInfo.vue';

    enum IconVariant {
        Green = 'green',
        Grey = 'grey',
        LightGreen = 'light-green',
    }

    enum TooltipIconType {
        Question = 'question',
        Mir = 'mir',
    }

    enum IconSpacing {
        Small = 'small', // 4px
        Medium = 'medium', // 8px
    }

    interface MirCashbackContentProps {
        iconVariant?: `${IconVariant}`;
        tooltipIcon?: `${TooltipIconType}`;
        iconSpacing?: `${IconSpacing}`;
        contentClass?: string;
        autoShowTooltip?: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MirCashbackBadge',
  props: {
    iconVariant: { default: 'green' },
    tooltipIcon: { default: 'question' },
    iconSpacing: { default: 'small' },
    contentClass: { default: '' },
    autoShowTooltip: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { iconVariant: `${IconVariant}`, tooltipIcon: `${TooltipIconType}`, iconSpacing: `${IconSpacing}`, contentClass: string, autoShowTooltip: boolean }

    

    const hasDefaultTooltip = computed(() => props.tooltipIcon === TooltipIconType.Question);
    const tooltipComponent = computed(() => (hasDefaultTooltip.value ? Icon : MirCashbackIcon));
    const tooltipType = computed(() => (hasDefaultTooltip.value ? 'black' : 'white'));

return { __sfc: true,IconVariant, TooltipIconType, IconSpacing, props, hasDefaultTooltip, tooltipComponent, tooltipType, Typo, MIR_CASHBACK_TEXT, MirCashbackIcon, MirCashbackInfo }
}

})